import react from "react";
import { classNames } from "../../utils/helpers";

export default function SectionCard({ title, right, children, isRetailerMobile }) {
  return (
    <div
        className={classNames(
          "rounded-2xl p-4 flex flex-col min-h-[300px] transition-all duration-300",
          isRetailerMobile
            ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
            : "bg-white/90 border border-slate-100/80 shadow-sm hover:shadow-md",
          
        )}
      >
      <div className="flex items-center justify-between mb-3 gap-2">
        <h2 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
          {title}
        </h2>
        {right}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}